import { Controller } from "@hotwired/stimulus"
import componentOptions from "../src/shopify-buy-button-config"

const initialDialogComponentOptions = componentOptions()
initialDialogComponentOptions.product.order = ['button']
initialDialogComponentOptions.product.text.button = 'I need a badge'
delete initialDialogComponentOptions.product.styles.product
delete initialDialogComponentOptions.product.buttonDestination

initialDialogComponentOptions.product.events = {
  addVariantToCart: () => { window.showProductGrid() },
}

// Connects to data-controller="shopify-product"
export default class extends Controller {
  static targets = ["component"]
  static values = {
    id: String,
    initialDialog: {
      type: Boolean,
      default: false
    }
  }

  connect() {
    window.shopifyUi.createComponent('product', {
      id: this.idValue,
      node: this.componentTarget,
      moneyFormat: '%24%7B%7Bamount%7D%7D',
      options: this.initialDialogValue ? initialDialogComponentOptions : componentOptions(),
    });
  }
}
